// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressResult_wrapper__QbfuM","title":"AddressResult_title__jqtFd","contentWrapper":"AddressResult_contentWrapper__gNFSW"};